export const Periods = ['M1', 'M5', 'M15', 'M30', 'H1', 'Day'];
//# sourceMappingURL=types.js.map